/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_Report_Note_PlaceholderInputs */

const en_us2_exercise_sheet_report_note_placeholder = /** @type {(inputs: Exercise_Sheet_Report_Note_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E.g. the video shows another exercise`)
};

const pt_br2_exercise_sheet_report_note_placeholder = /** @type {(inputs: Exercise_Sheet_Report_Note_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ex.: o vídeo mostra outro exercício`)
};

const es_419_exercise_sheet_report_note_placeholder = /** @type {(inputs: Exercise_Sheet_Report_Note_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ej.: el video muestra otro ejercicio`)
};

const pt_pt2_exercise_sheet_report_note_placeholder = /** @type {(inputs: Exercise_Sheet_Report_Note_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ex.: o vídeo mostra outro exercício`)
};

const fr_fr2_exercise_sheet_report_note_placeholder = /** @type {(inputs: Exercise_Sheet_Report_Note_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ex. : la vidéo montre un autre exercice`)
};

const de_de2_exercise_sheet_report_note_placeholder = /** @type {(inputs: Exercise_Sheet_Report_Note_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Z. B. das Video zeigt eine andere Übung`)
};

const it_it2_exercise_sheet_report_note_placeholder = /** @type {(inputs: Exercise_Sheet_Report_Note_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es. il video mostra un altro esercizio`)
};

/**
* | output |
* | --- |
* | "E.g. the video shows another exercise" |
*
* @param {Exercise_Sheet_Report_Note_PlaceholderInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_report_note_placeholder = /** @type {((inputs?: Exercise_Sheet_Report_Note_PlaceholderInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Report_Note_PlaceholderInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_report_note_placeholder(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_report_note_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_report_note_placeholder(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_report_note_placeholder(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_report_note_placeholder(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_report_note_placeholder(inputs)
	return en_us2_exercise_sheet_report_note_placeholder(inputs)
});
export { exercise_sheet_report_note_placeholder as "exercise-sheet.report_note_placeholder" }